import { getDeviationResourceType } from '../DeviationViews/_helpers';
import { DeviationResourceType } from '../types/deviation';
import { ResourceType } from '../types/resource';
export function getRecipientSectionName(typeId) {
    var recipientType;
    if (DeviationResourceType[typeId]) {
        recipientType = 'deviation';
    }
    else if (typeId === ResourceType.COMMENT) {
        recipientType = 'comments';
    }
    return recipientType;
}
export function getRecipientForDeviation(deviation) {
    return {
        typeId: getDeviationResourceType(deviation),
        itemId: deviation.deviationId,
        user: deviation.author,
    };
}
export function getRecipientForComment(comment) {
    return {
        comment: comment,
        typeId: ResourceType.COMMENT,
        itemId: comment.commentId,
        user: comment.user,
    };
}
export var badgeNotificationsFilter = function (badgeName) { return function (notification) { var _a, _b; return ((_b = (_a = notification.params) === null || _a === void 0 ? void 0 : _a.badge) === null || _b === void 0 ? void 0 : _b.name) === badgeName; }; };
//# sourceMappingURL=utils.js.map